module.exports = __webpack_public_path__ + "static/chicken-biscuit-mug.36f5ce9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chicken-biscuit-mug.jpg
// module id = 61
// module chunks = 35783957827783 36733297554888 114276838955818